<template>
  <div class="message">
    <slot name="icon"/>
    <div class="message_content">
      <slot name="message"/>
    </div>
    <p class="message_link" v-if="autoDashboardRedirect || dashboardRedirectLink" @click="redirect">{{ $t('Вернуться на главную' )}}</p>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { REDIRECT_DELAY } from '@/constants'

@Component
class Message extends Vue {
  @Prop({ default: false, type: Boolean }) autoDashboardRedirect
  @Prop({ default: false, type: Boolean }) dashboardRedirectLink

  mounted () {
    if (this.autoDashboardRedirect) {
      this.timeout = setTimeout(() => this.redirect(), REDIRECT_DELAY)
    }
  }

  beforeDestroy () {
    clearTimeout(this.timeout)
  }

  redirect () {
    // Callback is necessary to reload application state when error
    this.$router.replace(({ name: 'dashboard' }), () => this.$router.go())
  }
}

export default Message
</script>

<style lang="scss">
.message {
  @extend %layout;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: none;
  min-height: 100%;
  padding-top: 35px;
  padding-bottom: 35px;

  &_content {
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 15px;
    margin-bottom: 55px;
    text-align: center;
    @include media_tablet {
      font-size: 24px;
      margin-bottom: 80px;
    }
  }
  &_link {
    cursor: pointer;
    color: #fff;
    border-bottom: 1px solid;
    font-size: 12px;
    @include media_tablet {
      font-size: 14px;
    }
  }
}
</style>
